import api, { mailerServiceApi } from './api';
import { experimentationRoutes, GET, POST } from '../constants/api';

export const getExperimentFeatures = () =>
  api({
    method: GET,
    url: `${experimentationRoutes.GET_FEATURES}`,
  });

export const sendExperimentationEmails = (data: Object) =>
  mailerServiceApi({
    method: POST,
    url: `${experimentationRoutes.SEND_EMAILS}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const validateExperimentationCsv = data =>
  mailerServiceApi({
    method: POST,
    url: `${experimentationRoutes.VALIDATE_CSV}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getExperimentFlags = () =>
  api({
    method: GET,
    url: `${experimentationRoutes.GET_FLAGS}`,
  });

export const getAllFeatures = () =>
  api({
    method: GET,
    url: `${experimentationRoutes.GET_ALL_FEATURES}`,
  });
